import React from "react";
// REDUX
import { useSelector } from "react-redux";
// NAVIGATION
import { useLocation } from "react-router-dom";
// CUSTOM HOOKS
import useGetOneAdapter from "../../../../customHooks/GET_requests/useGetOneAdapter";
// COMPONENTS
import IconDefinitionConditionsTable from "./IconDefinitionConditionsTable";
import IconDefinitionRules from "./IconDefinitionRules";
// INTERFACES
import { RootState } from "../../../../app/store";
import { LiftType } from "../../../../flatbuffers/generated/archive/lift-type";
import IconDefinitionHallCallBindings from "./IconDefinitionHallCallBindings";

export default function IconDefinitionPage() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const adapterId = new URLSearchParams(location.search).get("idAdapter");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { adapter, isLoadingGetOneAdapter } = useGetOneAdapter({
    id: adapterId ?? "",
  });

  // ************************************************ */
  // HELPERS **************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // USE MEMO *************************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE CALLBACK *********************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {(adapter?.liftType === LiftType.ELEVATOR || adapter?.liftType === LiftType.ESCALATOR) && (
        <div className={`layout__contentPage__${theme} mt-3`}>
          <IconDefinitionConditionsTable adapter={adapter} isLoading={isLoadingGetOneAdapter} />
          <IconDefinitionRules adapter={adapter} isLoading={isLoadingGetOneAdapter} />
          <IconDefinitionHallCallBindings adapter={adapter} isLoading={isLoadingGetOneAdapter} />
        </div>
      )}
    </div>
  );
}
